<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconShare_16"
    viewBox="0 0 16 16"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        d="M3.8 3A2.8 2.8 0 0 0 1 5.8v4.667a2.8 2.8 0 0 0 2.8 2.8h3.57V8.2L5.092 9.504c-.179.104-.398.042-.515-.146a.53.53 0 0 1 .043-.61l3.09-3.562a.382.382 0 0 1 .58 0l3.09 3.562c.142.163.16.421.043.61-.116.185-.334.25-.514.146L8.63 8.2v5.067h3.57a2.8 2.8 0 0 0 2.8-2.8V5.8A2.8 2.8 0 0 0 12.2 3z"
    />
</svg>
